'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$17() {
  this.bee = null;
  this.bec = null;
  this.bed = false;
  this.bea = null;
  this.beb = false;
  this.bef = false;
  this.beg = false;
  this.bee = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$17 as $c_Lpresto_PrestoRouter$$anon$17 };
$p = $c_Lpresto_PrestoRouter$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$17;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$17() {
}
export { $h_Lpresto_PrestoRouter$$anon$17 as $h_Lpresto_PrestoRouter$$anon$17 };
$h_Lpresto_PrestoRouter$$anon$17.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bee;
});
$p.t = (function() {
  if ((!this.bed)) {
    this.bec = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bed = true;
  }
  return this.bec;
});
$p.ad = (function() {
  if ((!this.beb)) {
    this.bea = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beb = true;
  }
  return this.bea;
});
$p.v = (function() {
  if ((!this.beg)) {
    this.bef = false;
    this.beg = true;
  }
  return this.bef;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$17, "presto.PrestoRouter$$anon$17", ({
  NQ: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$17 as $d_Lpresto_PrestoRouter$$anon$17 };
//# sourceMappingURL=presto.-Presto-Router$$anon$17.js.map
